module.exports = __webpack_public_path__ + "static/img/histoire-landing.0ea3b24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/histoire-landing.png
// module id = 94
// module chunks = 0